// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentCaseRelationshipsModel {
    static getAttributeTypeMap() {
        return EnrollmentCaseRelationshipsModel.attributeTypeMap;
    }
}
EnrollmentCaseRelationshipsModel.discriminator = undefined;
EnrollmentCaseRelationshipsModel.attributeTypeMap = [
    {
        "name": "prescribers",
        "baseName": "prescribers",
        "type": "Array<EnrollmentCaseRelationshipModel>"
    },
    {
        "name": "prescriptions",
        "baseName": "prescriptions",
        "type": "Array<EnrollmentCasePrescriptionRelationshipModel>"
    },
    {
        "name": "sites",
        "baseName": "sites",
        "type": "Array<EnrollmentCaseRelationshipModel>"
    },
    {
        "name": "payors",
        "baseName": "payors",
        "type": "Array<EnrollmentCaseRoleTypeRelationshipModel>"
    },
    {
        "name": "pharmacies",
        "baseName": "pharmacies",
        "type": "Array<EnrollmentCaseRelationshipModel>"
    },
    {
        "name": "documents",
        "baseName": "documents",
        "type": "Array<EnrollmentCaseDocumentRelationshipModel>"
    },
    {
        "name": "notes",
        "baseName": "notes",
        "type": "Array<number>"
    },
    {
        "name": "tasks",
        "baseName": "tasks",
        "type": "Array<number>"
    }
];
//# sourceMappingURL=enrollmentCaseRelationshipsModel.js.map